import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  headerWrapper: {
    justifyContent: 'space-between',

    paddingTop: SPACES.xxxl,
    paddingBottom: SPACES.xxxxxxl,
    paddingLeft: SPACES.xxxxl,
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: SPACES.l,
  },
}))

export default useStyles
